import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const HeroSection = () => {
  const [offsetY, setOffsetY] = useState(0);

  const handleScroll = () => {
    setOffsetY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section
      className="space-ptb bg-overlay-black-80"
      style={{
        backgroundImage: `url(/images/bg/banner.png)`, // ✅ Your image here
        backgroundPositionY: `${offsetY * 0.5}px`, // Adjust speed here
      }}
    >
     
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <span className="text-white d-block mb-4 h6 font-weight-normal">
                Are you ready to start your journey with Pioneer?
              </span>
              <h2 className="text-white mb-4 display-7">
                Education for Individual and Social Responsibility
              </h2>
              <div className="d-flex gap-2 justify-content-center">
                <Link to={'/Contact'} className="btn btn-primary mr-sm-3 mt-3">
                  Become Our Student
                </Link>
                <Link to={'/About'} className="btn btn-white mt-3">
                  Discover More
                </Link>
                </div>
            </div>
          </div>
        </div>
     
    </section>
  );
};

export default HeroSection;
